// context/HttpErrorContext.js
import { createContext, useContext, useState } from 'react';

const HttpErrorContext = createContext(null);

export const HttpErrorProvider = ({ children }) => {
  const [httpError, setHttpError] = useState(null);
  return (
    <HttpErrorContext.Provider value={{ httpError, setHttpError }}>
      {children}
    </HttpErrorContext.Provider>
  );
};

export const useHttpError = () => useContext(HttpErrorContext);